import { render, staticRenderFns } from "./WasteConfirmToDrop.vue?vue&type=template&id=f912150e&scoped=true&"
import script from "./WasteConfirmToDrop.vue?vue&type=script&lang=js&"
export * from "./WasteConfirmToDrop.vue?vue&type=script&lang=js&"
import style0 from "./WasteConfirmToDrop.vue?vue&type=style&index=0&id=f912150e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f912150e",
  null
  
)

export default component.exports